import { createFileRoute } from "@tanstack/react-router";
import { SettingsNav } from "@/app/shell/settings-nav";
import { ProfileCard } from "@/features/patients";

export const Route = createFileRoute("/settings/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { medplum, profile } = Route.useRouteContext();

  return (
    <div className="py-12 space-y-6">
      <SettingsNav />
      <div className="max-w-(--form-max-width) mx-auto">
        <ProfileCard profile={profile} project={medplum.getProject()} />
      </div>
    </div>
  );
}
